<div [formGroup]="form" class="grid align-items-center">
  <div class="col-12 md:col-4">
    <tj-field label="Name">
      <input
        id="name"
        type="text"
        pInputText
        formControlName="name"
        placeholder="Name"
      />
    </tj-field>
  </div>

  <div class="col-12 md:col-4">
    <tj-field label="Code">
      <input
        id="code"
        type="text"
        pInputText
        formControlName="code"
        placeholder="Code"
      />
    </tj-field>
  </div>

  <div class="col-12 md:col-4">
    <tj-field label="Zip Code">
      <input
        id="zipCode"
        type="text"
        pInputText
        formControlName="zipCode"
        placeholder="Zip Code"
      />
    </tj-field>
  </div>
</div>
